import React, { useEffect, useState } from "react";


const frases = [
  "«La suerte de tu día depende de cómo lo afrontes desde primera hora de la mañana»",
  "«Cuida esos primeros minutos como la semilla de tu día, porque eso es lo que son. No los contamines mirando el correo ni las redes sociales.»",
  "«Sé el cambio que quieres ver en el mundo» — Gandhi",
  "«Qué maravilloso es que nadie tenga que esperar ni un segundo para empezar a mejorar el mundo» — Ana Frank",
  "«El pesimista ve dificultades en cada oportunidad. El optimista ve oportunidades en cada dificultad» —Winston Churchill",
  "«Muchos piensan en cambiar el mundo, pero casi nadie piensa en cambiarse a sí mismo» — Leon Tolstoi",
  "«Si estás trabajando en algo que te importa de verdad, nadie tiene que empujarte: tu visión te empuja» — Steve Jobs"
];

function MotivacionalSentences(){
    const [sentences, setSentences] = useState('');

    const getRandomSentences= () =>{
        const randomIndex = Math.floor(Math.random()* frases.length);
        setSentences(frases[randomIndex]); 
    };

    useEffect(() => {
        getRandomSentences();
    }, []);

    return (
        <div className="izquierda" onClick={getRandomSentences}>
            <h3>{sentences}</h3>
        </div>
    );
}

export default MotivacionalSentences;